<style lang="scss" scoped>
.shorten {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 350px;
  cursor: default !important;
}
</style>

<template>
  <td>
    <v-button class="shorten" v-tooltip:auto="content">
      {{ content }}
    </v-button>
  </td>
</template>

<script>
export default {
  props: ["content"]
};
</script>
